import svg4everybody from 'svg4everybody';

import * as LangMenu from '../blocks/lang-menu/lang-menu';

svg4everybody();

LangMenu.initBlock();
